import type { RegionCode } from "@/api/filter";
import { useRegion } from "@/hooks/useRegion";

const brands: {
  brandName: string;
  url: string;
  /** Label override for specific regions (MICS-86). */
  regionBrandName?: Partial<Record<RegionCode, string>>;
}[] = [
  { brandName: "PEM", url: "https://www.pemnet.com" },
  { brandName: "PROFIL", url: "https://www.profil-global.com" },
  { brandName: "Haeger by PEM", url: "https://www.haeger.com" },
  { brandName: "MDS", url: "https://www.autoriv.com" },
  {
    brandName: "Sherex",
    url: "https://www.sherex.com",
    regionBrandName: { EU: "Sherex by PEM" },
  },
];

export const SubNavBar = () => {
  const region = useRegion();
  return (
    <div className="w-full bg-penn-900 fixed top-0 z-40 overflow-x-auto">
      <div className="mx-auto w-max px-3 sm:px-6 h-10 flex items-center gap-4 sm:gap-8">
        {brands.map((brand) => (
          <a
            key={brand.brandName}
            href={brand.url}
            target="_blank"
            rel="noopener noreferrer"
            className="shrink-0 whitespace-nowrap text-white/80 hover:text-white transition-opacity no-underline hover:underline underline-offset-4 text-nav"
          >
            {brand.regionBrandName?.[region] ?? brand.brandName}
          </a>
        ))}
      </div>
    </div>
  );
};
